import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TrainingDomainsHeadingListComponent } from './training-domains-heading-list/training-domains-heading-list.component';
import { TrainingDomainsHeadingCreateComponent } from './training-domains-heading-create/training-domains-heading-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: TrainingDomainsHeadingListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: TrainingDomainsHeadingCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'training-domains-heading-create/:id',
        component: TrainingDomainsHeadingCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrainingDomainsHeadingRoutingModule { }
